import Globals from '../Globals';

export default {
  ...Globals,

  primary: '#1B82DD',
  primarySlightFade: '#499ee9',
  primaryFade: '#c4e0f8',
  primaryDarker: '#cb7a01',

  qfb1: '#200E5C',
  qfb1Fade: '#8668e8',
  qfb2: '#410085',
  qfb2Fade: '#7e5fe4',
  qfb3: '#2D51C4',
  qfb3Fade: '#d5ddf6',
  qfb4Dark: '#0f5dd1',
  qfb4: '#1B82DD',
  qfb4Fade: '#c4e0f8',
  qfb5: '#2BAAE3',
  qfb6: '#86EDEF',
  qfb7: '#E684C3',
  qfb7Fade: '#f7d9ed',
  qfb8: '#FFDEE8',

  secondary: '#2BAAE3',
};
